<template>
  <div class="home">
    <div class="header">
      <h1>{{ systemName }}</h1>
      <div class="company-name">{{ companyName }}</div>
      <div class="user-info">
        <span v-if="!isAdmin" class="location-badge">{{ locationName }}</span>
        <span class="user-type">{{ userRoleLabel }}</span>
        <span v-if="currentUsername" class="username">({{ currentUsername }})</span>
        <button @click="handleLogout" class="logout-btn">退出登录</button>
      </div>
    </div>
    <div class="main-container">
      <div class="sidebar">
        <nav>
          <router-link :to="statusNavTarget" class="nav-item">
            <i class="fas fa-chart-line"></i>
            {{ isAdmin ? '系统状态检测' : '公司管理' }}
          </router-link>
          <router-link to="/control" class="nav-item">
            <i class="fas fa-cogs"></i>
            远程控制管理
          </router-link>
          <router-link to="/data-screen" class="nav-item">
            <i class="fas fa-tv"></i>
            数据大屏
          </router-link>
          <router-link to="/door-analytics" class="nav-item">
            <i class="fas fa-chart-pie"></i>
            数据分析看板
          </router-link>
          <router-link to="/history-data" class="nav-item">
            <i class="fas fa-database"></i>
            历史数据查看
          </router-link>
          <router-link to="/parts" class="nav-item">
            <i class="fas fa-tools"></i>
            配件清单管理
          </router-link>
          <router-link to="/maintenance" class="nav-item">
            <i class="fas fa-clipboard-list"></i>
            保养记录管理
          </router-link>
          <router-link to="/admin-brand" class="nav-item">
            <i class="fas fa-user-cog"></i>
            管理员用户管理
          </router-link>
        </nav>
      </div>
      <div class="content" :class="{ 'full-width': isLocationUser, 'screen-content': isScreenRoute }">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      systemName: '智能物联网自动门管理系统',
      companyName: '南京希丹维特自动门有限公司'
    };
  },
  computed: {
    isAdmin() {
      return localStorage.getItem('userType') === 'admin';
    },
    isLocationUser() {
      return localStorage.getItem('userType') === 'location';
    },
    locationName() {
      return localStorage.getItem('locationName') || '客户位置';
    },
    statusNavTarget() {
      if (this.isAdmin) return '/locations';
      const locationId = localStorage.getItem('locationId');
      return locationId ? `/state/${locationId}` : '/state';
    },
    userRoleLabel() {
      const role = (localStorage.getItem('userRole') || '').toUpperCase();
      if (role === 'SUPER_ADMIN') return '超级管理员';
      if (role === 'ADMIN') return '管理员';
      if (role === 'HOSPITAL_USER') return '客户用户';
      return this.isAdmin ? '管理员' : '客户用户';
    },
    currentUsername() {
      return localStorage.getItem('username') || '';
    },
    isScreenRoute() {
      return this.$route.meta.screen === true;
    }
  },
  methods: {
    loadBrand() {
      const isLocationUser = localStorage.getItem('userType') === 'location';
      const locationId = localStorage.getItem('locationId');

      if (isLocationUser && locationId) {
        // 客户用户：读取带 locationId 的 key
        this.systemName = localStorage.getItem(`systemName_${locationId}`) || '智能物联网自动门管理系统';
        this.companyName = localStorage.getItem(`companyName_${locationId}`) || '南京希丹维特自动门有限公司';
      } else {
        // 管理员：读取全局 key
        this.systemName = localStorage.getItem('systemName') || '智能物联网自动门管理系统';
        this.companyName = localStorage.getItem('companyName') || '南京希丹维特自动门有限公司';
      }
    },
    handleLogout() {
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('userType');
      localStorage.removeItem('authToken');
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('locationId');
      localStorage.removeItem('locationName');
      localStorage.removeItem('userRole');
      localStorage.removeItem('username');
      this.$router.replace('/login');
    }
  },
  mounted() {
    this.loadBrand();
    // 监听跨组件或跨标签页的品牌更新事件
    window.addEventListener('brand-updated', this.loadBrand);
    window.addEventListener('storage', this.loadBrand);
  },
  beforeUnmount() {
    window.removeEventListener('brand-updated', this.loadBrand);
    window.removeEventListener('storage', this.loadBrand);
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
  background: linear-gradient(to bottom right, #0a0e29, #1a1f4b);
  color: white;
}

.header {
  padding: 20px;
  text-align: center;
  background: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 243, 255, 0.2);
  position: relative;
}

h1 {
  color: #00f3ff;
  margin: 0;
  font-size: 2em;
  text-shadow: 0 0 10px rgba(0, 243, 255, 0.5);
}

.company-name {
  color: rgba(255, 255, 255, 0.8);
  margin-top: 10px;
  font-size: 1.2em;
}

.user-info {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.location-badge {
  background: rgba(0, 243, 255, 0.2);
  color: #00f3ff;
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 0.9em;
  border: 1px solid rgba(0, 243, 255, 0.3);
}

.user-type {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9em;
}

.username {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9em;
}

.logout-btn {
  background: rgba(255, 71, 87, 0.2);
  color: #ff4757;
  border: 1px solid rgba(255, 71, 87, 0.3);
  padding: 6px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  transition: all 0.3s;
}

.logout-btn:hover {
  background: rgba(255, 71, 87, 0.3);
  border-color: #ff4757;
}

.main-container {
  display: flex;
  min-height: calc(100vh - 120px);
}

.sidebar {
  width: 250px;
  background: rgba(0, 0, 0, 0.3);
  padding: 20px;
  border-right: 1px solid rgba(0, 243, 255, 0.2);
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 15px;
  color: white;
  text-decoration: none;
  margin-bottom: 10px;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.nav-item:hover {
  background: rgba(0, 243, 255, 0.1);
  color: #00f3ff;
}

.nav-item i {
  margin-right: 10px;
}

.nav-item.router-link-active {
  background: rgba(0, 243, 255, 0.2);
  color: #00f3ff;
}

.content {
  flex: 1;
  padding: 20px;
  background: rgba(0, 0, 0, 0.1);
  overflow: visible;
}

.content.full-width {
  width: 100%;
  max-width: 100%;
}

.content.screen-content {
  padding: 0;
  overflow: hidden;
  background: transparent;
}
</style> 